import { FunctionComponent, useContext, useEffect, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { HiddenNavContext } from 'providers/hiddenNav';

import { Routes } from 'types/routes';

import IconSuccess from 'theme/icons/check-green.svg';
import PhysioIcon from 'theme/icons/physio.svg';

import CompanyRegisterFormSection from 'components/content/sections/forms/CompanyRegisterForm';
import FormResultInfo from 'components/content/sections/forms/FormResultInfo';
import Button from 'components/layout/Button';
import Header from 'components/layout/Header';
import { HeaderStyles } from 'components/layout/Header/types';

import StyledComponent from './styles';
import { Props } from './types';

enum States {
    Form = 'form',
    Success = 'success',
}

const PageRegisterCompanySectionForm: FunctionComponent<Props> = ({ translations }) => {
    const [state, setState]: [States, Function] = useState(States.Form);
    const [_, setHiddenNav]: [boolean, Function] = useContext(HiddenNavContext);

    const router = useRouter();

    useEffect(() => {
        setHiddenNav(true);

        return () => setHiddenNav(false);
    }, []);

    return (
        <StyledComponent className="page-register-company-section-form">
            <div className="columns">
                <div className="col col-left">
                    <Header
                        title={translations?.headerTitle}
                        description={state === States.Form && translations?.headerDescription}
                        isPrimaryTitle={true}
                        style={HeaderStyles.Form}
                    />
                    {state === States.Form ? (
                        <CompanyRegisterFormSection
                            onSuccess={() => setState(States.Success)}
                            translations={{ ...translations }}
                        />
                    ) : (
                        <FormResultInfo
                            title={translations?.resultFormTitle}
                            description={translations?.resultFormDescription}
                            icon={(
                                <Image
                                    src={IconSuccess}
                                />
                            )}
                        >
                            <Button
                                className="button-homepage"
                                onClick={() => router.push(Routes.PublicHome)}
                            >
                                {translations?.resultFormButton}
                            </Button>
                        </FormResultInfo>
                    )}
                </div>
                <div className="col col-right">
                    <div className="col-image">
                        <Image
                            src={PhysioIcon}
                        />
                    </div>
                </div>
            </div>
        </StyledComponent>
    );
};

export default PageRegisterCompanySectionForm;
